import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

export interface ReadonlyPromotionDescriptionBlockProps {
  promotionDescription: string;
}

const ReadonlyPromotionDescriptionBlock = ({
  promotionDescription,
}: ReadonlyPromotionDescriptionBlockProps) => {
  const { t } = useTranslation("orders");
  const theme = useTheme();

  return (
    <Box
      data-testid="readonly-promotion-description-block"
      sx={{ textAlign: "left" }}
    >
      <Typography
        sx={{
          fontWeight: theme.tokens.FuelFontWeightSemibold,
          paddingBottom: theme.tokens.FuelSpacing2,
        }}
      >
        {t("orderSummary.header.promotionDescription")}
      </Typography>
      <Typography data-testid="readonly-promotion-description">
        {promotionDescription}
      </Typography>
    </Box>
  );
};

export default ReadonlyPromotionDescriptionBlock;
